// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__ycDvy","select":"Header_select__lmmyN","clinic":"Header_clinic__2XvUF"};